import { EmailArtifactPayloadTypename, HtmlArtifactPayloadTypename, MarkdownArtifactPayloadTypename } from 'chatspot-core/__generated__/chirp/com/hubspot/copilot/rpc/v2/CopilotMessageService';
import { lazy } from 'react';
const LazyDefaultArtifactCardFormatter = /*#__PURE__*/lazy(() => import('./DefaultArtifactCardFormatter'));
const LazyEmailArtifactCardFormatter = /*#__PURE__*/lazy(() => import('./EmailArtifactCardFormatter'));
const artifactCardRegistry = {
  [EmailArtifactPayloadTypename]: LazyEmailArtifactCardFormatter,
  [HtmlArtifactPayloadTypename]: LazyDefaultArtifactCardFormatter,
  [MarkdownArtifactPayloadTypename]: LazyDefaultArtifactCardFormatter
};
export const getArtifactCardFormatter = payloadTypename => payloadTypename && artifactCardRegistry[payloadTypename] || LazyDefaultArtifactCardFormatter;